import axios from 'axios'

export default {
  openDevice(data) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'http://127.0.0.1:19196/openDevice',
        method: 'GET'
      }).then( res=>{
        let data  = res.data;
        let result = data;
        if( result.resultFlag == 0){
          resolve( result )
        }else{
          reject(res.data);
        }
      }).catch( err => {
        reject(err);
      })
    })
  },
  readIdCard(data) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'http://127.0.0.1:19196/readcard',
        method: 'GET'
      }).then( res=>{
        let data  = res.data;
        let result = data;
        if( result.resultFlag == 0){
          resolve( result )
        }else{
          reject(res.data);
        }
      }).catch( err => {
        reject(err);
      })
    })
  },
  closeDevice(data) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'http://127.0.0.1:19196/closeDevice',
        method: 'GET'
      }).then( res=>{
        let data  = res.data;
        let result = data;
        if( result.resultFlag == 0){
          resolve( result )
        }else{
          reject(res.data);
        }
      }).catch( err => {
        reject(err);
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/reader.js